module.exports = __webpack_public_path__ + "img/SES_4069004800.fd459fad.jpg";